import { render, staticRenderFns } from "./customer-form.vue?vue&type=template&id=ef706dca&scoped=true"
import script from "./customer-form.vue?vue&type=script&lang=ts"
export * from "./customer-form.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./customer-form.vue?vue&type=style&index=1&id=ef706dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef706dca",
  null
  
)

export default component.exports